import request from "@/utils/request";

// 角色-不分页查询
export const postRoleList = (data) => {
  return request({
    url: "/role/list",
    method: "post",
    data,
  });
};
